import React, { createContext, ReactNode, useContext } from 'react';
import { ClientConfigDto } from '../services/service';

interface SettingsContextType {
    settings: ClientConfigDto | undefined;
    isLoading: boolean;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};

export const SettingsProvider: React.FC<{
    children: ReactNode;
    settings: ClientConfigDto | undefined;
    isLoading: boolean;
}> = ({ children, settings, isLoading }) => {
    return (
        <SettingsContext.Provider value={{ settings, isLoading }}>
            {children}
        </SettingsContext.Provider>
    );
};